import { defineMessages } from "react-intl";

export const messages = defineMessages({
  successful: {
    id: "ari.management.toast.successful",
    defaultMessage: "Saved successfully"
  },
  error: {
    id: "ari.management.toast.error",
    defaultMessage: "Unexpected error"
  },
  updateError: {
    id: "ari.management.toast.updateError",
    defaultMessage: "Error while saving"
  }
});
